import { render, staticRenderFns } from "./SafeFile.vue?vue&type=template&id=b5bb27d8"
import script from "./SafeFile.vue?vue&type=script&lang=js"
export * from "./SafeFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports